module.exports = "<!--The content below is only a placeholder and can be replaced.-->\r\n<app-loading></app-loading>\r\n<router-outlet></router-outlet>"